function waitForIceComplete(pc, timeoutMs) {
    return new Promise((resolve) => {
        if (!pc) {
            resolve({ ok: false, reason: 'no-pc' });
            return;
        }
        if (pc.iceGatheringState === 'complete') {
            resolve({ ok: true, reached: 'already' });
            return;
        }
        let done = false;
        const onChange = () => {
            if (pc.iceGatheringState === 'complete' && !done) {
                done = true;
                pc.removeEventListener('icegatheringstatechange', onChange);
                resolve({ ok: true, reached: 'event' });
            }
        };
        pc.addEventListener('icegatheringstatechange', onChange);
        setTimeout(() => {
            if (done)
                return;
            done = true;
            pc.removeEventListener('icegatheringstatechange', onChange);
            resolve({ ok: pc.iceGatheringState === 'complete', reached: 'timeout' });
        }, timeoutMs);
    });
}
export default async function windowsChromiumIceWarmup({ iceServers = [], timeoutMs = 1000 }) {
    const pc1 = new RTCPeerConnection({ iceServers, iceCandidatePoolSize: 1 });
    const pc2 = new RTCPeerConnection({ iceServers, iceCandidatePoolSize: 1 });
    const candidates = { pc1: [], pc2: [] };
    pc1.onicecandidate = (e) => {
        if (e.candidate && e.candidate.type !== 'host') {
            candidates.pc1.push(e.candidate);
        }
    };
    await pc1.createDataChannel('warmup');
    await pc1.addTransceiver('audio');
    const offer = await pc1.createOffer();
    await pc1.setLocalDescription(offer);
    await waitForIceComplete(pc1, timeoutMs);
    await pc2.setRemoteDescription(offer);
    pc2.onicecandidate = (e) => {
        if (e.candidate && e.candidate.type !== 'host') {
            candidates.pc2.push(e.candidate);
        }
    };
    const answer = await pc2.createAnswer();
    await pc2.setLocalDescription(answer);
    await pc1.setRemoteDescription(answer);
    await waitForIceComplete(pc2, timeoutMs);
    await Promise.all([
        ...candidates.pc1.map((candidate) => pc2.addIceCandidate(candidate).catch(console.error)),
        ...candidates.pc2.map((candidate) => pc1.addIceCandidate(candidate).catch(console.error)),
    ]);
    pc1.close();
    pc2.close();
}
